import {Injectable, inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map, Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {SendInvitationRequestInterface} from '../models/send-invite.model';
import {MarketingDataRequest} from '../models/marketingData.request';
import {transformMarketingDetails} from './marketing-detail/marketing-detail.transformer';
import {MarketingDetailsApiResponseInterface} from '../models/marketing-detail.model';
import {SupportRequestEmail} from '../models/SupportInformation.model';

@Injectable({providedIn: 'root'})

export class SalesService {
  private _httpClient: HttpClient = inject(HttpClient);

  public getMarketingDetails(plan: MarketingDataRequest): Observable<MarketingDetailsApiResponseInterface> {
    const url: string = `${environment.apiUrl}sales/purchase/portal/get-main-page-detail-for-plan`;
    return this._httpClient.get<MarketingDetailsApiResponseInterface>(`${url}?PracticeId=${plan.practice}&BenefitPlanTemplateId=${plan.template}&CoverageLevelName=${encodeURIComponent(plan.coverageLevelName)}&PageName=${plan.pageName}`).pipe(
      map((result: MarketingDetailsApiResponseInterface) => transformMarketingDetails(result))
    );
  }

  public sendInvitation(phoneNumber: string, captchaResponse: string, site: string): Observable<any> {
    const request: SendInvitationRequestInterface = {
      phoneNumber: phoneNumber,
      captchaResponse: captchaResponse,
      site : site
    };
    return this._httpClient.post<void>(`${environment.salesApiUrl}services/send-mysmile-invite`, request);
  }

  public sendSupportEmail(request: SupportRequestEmail): Observable<any> {
    return this._httpClient.post<void>(`${environment.salesApiUrl}purchase/portal/send-support-request-email`, request);
  }

  public selectPlan(plan: any): Observable<any> {
    return this._httpClient.post(`${environment.salesApiUrl}purchase/portal/select-plan`, {coverageLevelId: plan, source: 'MsdpPurchasePortal'});
  }
}
